<template>
    <b-card
        no-body
    >
        <div class="card-header align-items-start">
            <div class="card-group-title">
                <b-card-title>
                    {{ $t('org.billing.Daily Cost') }}
                </b-card-title>
            </div>
            <b-card-actions-container
                v-if="data.length"
                class="card-actions-container"
                @card:collapse="toggleMode"
            />
        </div>
        <b-card-body>
            <template v-if="data.length">
                <DailyLineChart
                    ref="container"
                    :svg="svg"
                    :mode="mode"
                    :data="data"
                    :status="status"
                    :month="month"
                    :projectIdx="projectIdx"
                    :dataWithCost="dataWithCost"
                    @resize:svg="handleResize"
                    @detail-layer="detailLayer"
                >
                </DailyLineChart>
                <DailyLineTable
                    v-show="mode === 'table'"
                    :data="data"
                    :dataWithCost="dataWithCost"
                    @detail-layer="detailLayerWithProduct"
                ></DailyLineTable>
            </template>
            <template v-else>
                <div class="d-flex justify-content-center align-items-center flex-column text-center">
                    <SVGEmptyIcon/>
                    <span>{{ $t('org.dashboard.No data') }}</span>
                </div>
            </template>
        </b-card-body>
    </b-card>
</template>

<script>
import BCardActionsContainer from '@/components/BCardActionsContainer'
import DailyLineChart from './DailyLineChart'
import DailyLineTable from './DailyLineTable'
import { ref, computed, toRefs } from '@vue/composition-api'
import SVGEmptyIcon from '@/assets/images/empty.svg'
export default {
    components: {
        BCardActionsContainer,
        DailyLineChart,
        DailyLineTable,
        SVGEmptyIcon
    },
    props: {
        data: {
            type: Array,
            default: function () {
                return []
            }
        },
        status: {
            type: String,
            default: ''
        },
        month: {
            type: String,
            default: ''
        },
        projectIdx: {
            type: Number,
            default: null
        }
    },
    setup (props, context) {
        const { data } = toRefs(props)
        const svg = ref({
            width: 100,
            height: 230,
            paddingL: 55,
            paddingR: 55,
            paddingT: 10,
            paddingB: 15
        })
        const mode = ref('graph')
        const container = ref(null)
        const dataWithCost = computed(() => {
            return data.value.filter(item => item.cost !== 0).map(item => {
                return {
                    cost: item.cost,
                    date: item.date,
                    products: item.products.sort((a, b) => Math.abs(a.cost) < Math.abs(b.cost) ? 1 : -1)
                }
            })
        })
        const handleResize = () => {
            if (container.value) {
                svg.value.width = container.value.$el.clientWidth
            }
        }
        const toggleMode = () => {
            mode.value = mode.value === 'graph' ? 'table' : 'graph'
        }
        const detailLayer = (date) => {
            context.emit('detail-layer', { date })
        }
        const detailLayerWithProduct = ({ date, productCode }) => {
            context.emit('detail-layer', { date, productCode })
        }
        return {
            svg,
            mode,
            container,
            dataWithCost,
            handleResize,
            toggleMode,
            detailLayer,
            detailLayerWithProduct
        }
    }
}
</script>

<style>
#containerDailyCost text.shadow {
    text-shadow: #fff 2px 2px 10px
}
#containerDailyCost .list-enter-active, #containerDailyCost .list-leave-active {
    transition: all 1s;
}
#containerDailyCost .list-enter  {
    opacity: 0;
    transform: translateY(30px);
}

#containerDailyCost .list-leave-to  {
    opacity: 0;
    transform: translateX(30px);
}
</style>
